"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpandoHeader = ExpandoHeader;
exports.ExpandoBody = ExpandoBody;
exports.default = Expando;
exports.ExpandoGroup = ExpandoGroup;
exports.Accordion = exports.RawExpando = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _get = _interopRequireDefault(require("lodash/get"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _Icon = _interopRequireDefault(require("../Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ExpandoHeader(props) {
  var children = props.children,
      className = props.className,
      onClick = props.onClick,
      open = props.open;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('frikin-expando-header', className),
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "frikin-expando-header-content"
  }, typeof children === 'function' ? children(props) : children), /*#__PURE__*/_react.default.createElement("span", {
    className: "frikin-expando-header-controls"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    fixedWidth: true,
    icon: open ? 'chevron-down' : 'chevron-left'
  })));
}

function ExpandoBody(props) {
  var children = props.children,
      className = props.className,
      open = props.open,
      persistContent = props.persistContent;
  return open || persistContent ? /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('frikin-expando-body', className)
  }, typeof children === 'function' ? children(props) : children) : null;
} // ===================================================== //


var RawExpando = /*#__PURE__*/function (_React$Component) {
  _inherits(RawExpando, _React$Component);

  var _super = _createSuper(RawExpando);

  function RawExpando() {
    var _this;

    _classCallCheck(this, RawExpando);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      open: _this.props.defaultOpen
    };

    _this.toggle = function () {
      return _this.setState({
        open: !_this.state.open
      });
    };

    return _this;
  }

  _createClass(RawExpando, [{
    key: "render",
    value: function render() {
      return this.props.children(_objectSpread({
        toggle: this.toggle
      }, this.state));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(newProps, oldState) {
      var open = oldState.open;
      if ('open' in newProps && newProps.open === true) open = newProps.open;
      return {
        open: open
      };
    }
  }]);

  return RawExpando;
}(_react.default.Component); // ===================================================== //


exports.RawExpando = RawExpando;

function Expando(props) {
  var className = props.className,
      header = props.header,
      children = props.children,
      persistContent = props.persistContent;
  return /*#__PURE__*/_react.default.createElement(RawExpando, props, function (_ref) {
    var toggle = _ref.toggle,
        open = _ref.open;
    var renderedHeader = typeof header === 'function' ? header(_objectSpread({
      toggle: toggle,
      open: open
    }, props)) : header,
        renderedBody = typeof children === 'function' ? children(_objectSpread({
      toggle: toggle,
      open: open
    }, props)) : children;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('frikin-expando', className, {
        'frikin-expando-open': open
      })
    }, /*#__PURE__*/_react.default.createElement(ExpandoHeader, {
      onClick: toggle,
      open: open
    }, renderedHeader), /*#__PURE__*/_react.default.createElement(ExpandoBody, {
      open: open,
      persistContent: persistContent
    }, renderedBody));
  });
}

Expando.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.any,
  header: _propTypes.default.any,
  persistContent: _propTypes.default.bool,
  open: _propTypes.default.bool
}; // ===================================================== //

function ExpandoGroup(props) {
  var items = props.items,
      header = props.header,
      children = props.children,
      open = props.open,
      className = props.className,
      defaultOpen = props.defaultOpen;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('frikin-expando-group', className)
  }, items.filter(function (item) {
    return !(0, _isEmpty.default)(item);
  }).map(function (item, idx) {
    return /*#__PURE__*/_react.default.createElement(Expando, {
      key: idx,
      item: item,
      open: open(item, idx) || item.open,
      header: header,
      children: children,
      defaultOpen: defaultOpen
    });
  }));
}

ExpandoGroup.propTypes = {
  items: _propTypes.default.array,
  className: _propTypes.default.string,
  header: _propTypes.default.func,
  children: _propTypes.default.func,
  open: _propTypes.default.func,
  defaultOpen: _propTypes.default.bool
};
ExpandoGroup.defaultProps = {
  header: function header(item) {
    return (0, _get.default)(item, 'header');
  },
  children: function children(item) {
    return (0, _get.default)(item, 'body');
  },
  open: function open() {
    return false;
  }
};
var Accordion = ExpandoGroup;
exports.Accordion = Accordion;